import { AxiosResponse } from 'axios';
import { AxiosConfig } from '../axios.config';

export type GetResponse = {
  currentYearSurveyCompletionStatus: string;
  dataList: any[];
  nm: string;
  nthCurrentYear: number;
  phase: number;
  phaseTotal: number;
};

export interface IGraphDataItem {
  nthYear: number;
  color: string;
  value: number;
  itemName: string;
}

export interface IDashboardDataListItem {
  colorLineInfo?: {
    greenMaxLine: number | null;
    orangeMaxLine: number | null;
    redMaxLine: number | null;
  };
  legendLineInfo?: number[];
  alertYn?: boolean;
  graph: IGraphDataItem[];
  graphCd: string; // 어떤 설문 그래프인지
  graphId: number;
  graphNm: string;
  maxValue: number;
  surveyType: string; // 어떤 설문 세트에 속하는지
  userType: string;
}

export interface IDashboardPageData {
  currentYearSurveyCompletionStatus: string;
  dataList: IDashboardDataListItem[];
  nm: string;
  nthCurrentYear: number;
  phase: number;
  phaseTotal: number;
}

export class DashboardAPI extends AxiosConfig {
  private _prefix = '/v1';
  private _url = `${this._prefix}/dashboard`;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(useBaseURL?: boolean, token?: string, device?: string) {
    super(useBaseURL, token, device);
  }

  /**
   * 07. 대시보드 API - 대시보드 조회
   * @see https://chc-app-api.huraydev.net/swagger-ui/index.html
   * @version 1.0.0
   */
  public getAsync = async (): Promise<AxiosResponse<IDashboardPageData>> => {
    return await this.instance.get<IDashboardPageData>(`${this._url}`);
  };
}
